// Which boot a session gets (2026-10-05): the light field app, or the full
// app with the network map. Pure (no DOM, no imports) so the frontend unit
// tests can run it under plain Node.

export type FieldBootWorkspace = "operations" | "construction";

function isField(w: string): w is FieldBootWorkspace {
  return w === "operations" || w === "construction";
}

/** The field workspace to boot straight into, or null for the full app.
 *  - `#field` / `#field=operations|construction` deep link (plain `#field`
 *    opens the field workspace this browser last used, else the first);
 *  - a user whose only workspaces are field ones (the original rule);
 *  - any other `#key=value` deep link (`#project=`, `#brief=`) -> full app;
 *  - the workspace this browser last used, if the user still has it;
 *  - otherwise a phone-sized screen boots a user who has a field
 *    workspace into it (they can switch to the rest from the dropdown).
 * `choices` is workspaces.ts:workspaceChoices for the user. */
export function fieldBootWorkspace(
  choices: string[],
  hash: string,
  stored: string | null,
  phone: boolean,
): FieldBootWorkspace | null {
  const field = choices.filter(isField);
  if (!field.length) return null;
  const m = /^#field(?:=(\w+))?$/.exec(hash);
  if (m) {
    const remembered = field.find((w) => w === stored);
    return field.find((w) => w === m[1]) ?? remembered ?? field[0];
  }
  if (field.length === choices.length) return field[0];
  if (/^#\w+=/.test(hash)) return null;
  if (stored && choices.includes(stored)) return isField(stored) ? stored : null;
  return phone ? field[0] : null;
}
